import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const Badge = ({ className, text, onClick, type, showDelete, dataTestId }) => {
  const classNames = getClassNames(type);
  const containerClassName = classnames({
    ...classNames.container,
    ...className,
  });

  return (
    <div className={containerClassName}>
      <span className={classnames(classNames.text)} data-testid={dataTestId || "badge"} >{text}</span>
      {showDelete && (
        <a
          href="#"
          className={classnames(classNames.link)}
          onClick={(e) => {
            e.preventDefault();
            onClick();
          }}
        >
          <svg
            className="w-2 h-2"
            stroke="currentColor"
            fill="none"
            viewBox="0 0 8 8"
          >
            <path
              strokeLinecap="round"
              strokeWidth="1.5"
              d="M1 1l6 6m0-6L1 7"
            />
          </svg>
        </a>
      )}
    </div>
  );
};

Badge.propTypes = {
  className: PropTypes.object,
  showDelete: PropTypes.bool,
  type: PropTypes.string,
  text: PropTypes.string.isRequired,
  onClick: PropTypes.func,
};

Badge.defaultProps = {
  className: {},
  onClick: () => {},
  showDelete: true,
};

const defaultLinkClassName = {
  flex: true,
  'items-center': true,
};
const defaultContainerClassName = {
  border: true,
  'border-solid': true,
  'items-center': true,
  'leading-none': true,
  'px-3 py-1': true,
  flex: true,
  'flex-shrink-0': true,
  'justify-center': true,
  'rounded-full': true,
};

const defaultTextClassName = {
  'font-medium': true,
  'text-left': true,
  'text-sm': true,
  block: true,
  'mr-2': true,
};

function getClassNames(type) {
  switch (type) {
    case 'black':
      return {
        container: {
          ...defaultContainerClassName,
          'bg-black': true,
          'border-black': true,
        },
        text: {
          ...defaultTextClassName,
          'text-white': true,
        },
        link: {
          ...defaultLinkClassName,
          'text-white': true,
        },
      };
    case 'green':
      return {
        container: {
          ...defaultContainerClassName,
          'bg-green': true,
          'border-green': true,
        },
        text: {
          ...defaultTextClassName,
          'text-white': true,
        },
        link: {
          ...defaultLinkClassName,
          'text-white': true,
        },
      };

    default:
      return {
        container: {
          ...defaultContainerClassName,
          'bg-white': true,
          'border-green': true,
        },
        text: {
          ...defaultTextClassName,
          'text-green': true,
        },
        link: {
          ...defaultLinkClassName,
          'text-green': true,
        },
      };
  }
}

export default Badge;
